import { Box, Container, Grid, CircularProgress } from "@mui/material";
import { Stack } from "@mui/system";
import EasySellBuy from "../easysellbuy";
import { useEffect, useState } from "react";

const Buybitcoin = () => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "خرید  ";

    // صبر برای اتمام رندر کامل صفحه
    const handleLoad = () => {
      setLoading(false);
    };

    // شبیه‌سازی رندر شدن EasySellBuy
    const timeoutId = setTimeout(handleLoad, 0);

    return () => clearTimeout(timeoutId);
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          bgcolor: "background.default",
        }}
      >
        <CircularProgress sx={{ color: "#fff" }} />
      </Box>
    );
  }

  return (
    <>
      <Box
        bgcolor={"background.default"}
        sx={{
          pb: 8,
          textAlign: "center",
        }}
      >
        <EasySellBuy />
      </Box>
    </>
  );
};

export default Buybitcoin;
